import React, { useRef, useEffect } from 'react';
import { View, ViewProps } from 'react-native';

export const NoTranslate: React.FC<React.PropsWithChildren<ViewProps>> = ({ children, ...props }) => {
  const ref = useRef<View>(null);

  useEffect(() => {
    if (ref.current) {
      const element = ref.current as unknown as HTMLElement;
      element.setAttribute('translate', 'no');
      element.classList.add('notranslate');
    }
  }, []);

  return (
    <View ref={ref} {...props}>
      {children}
    </View>
  );
};
